export default function showRaceDate(race) {
  var now = new Date();

  // NOTE: just use browser's local time because it's not clear what time zone `program_date` is in
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  var programDate = today;
  if (race) {
    programDate = new Date(race.get("program_date"));
  }

  return programDate > today;
}
